module.exports = __webpack_public_path__ + "components/country-flag/static/bw-11a901dac3238a26d6485736dc2b51c2.svg";